/**
 * Where new contacts come from, named wherever an MCP call cannot add one
 * (Anthropic directory review, 2026-10-02): consent is recorded where a
 * person opts in, never taken from a tool argument. One phrase, so every
 * surface names the same flows.
 */
export const NEW_CONTACT_SOURCES =
  'the in-app CSV import, a connected integration or your own sign-up flow on the Brew API'
